import { FileType } from './FileButton.types';

export const FILE_ACCEPT_VALUES: Record<FileType, string> = {
    image: 'image/*',
    table: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv'
};
